import React from 'react';

export const AUDIENCE_ROLES = [
  { value: 'board', label: 'Board', icon: 'groups' },
  { value: 'management', label: 'Management', icon: 'support_agent' },
  { value: 'homeowner', label: 'Homeowners', icon: 'home' },
];

const AudienceCheckboxGroup = ({ value = [], onChange }) => {
  const toggleRole = (role) => {
    const next = value.includes(role)
      ? value.filter((item) => item !== role)
      : [...value, role];
    onChange(next);
  };

  return (
    <div className="bg-section-bg rounded-2xl border border-amber-100/30 p-4">
      <label className="block text-xs font-bold text-slate-500 mb-3 uppercase tracking-widest">
        Visible to
      </label>
      <div className="flex flex-wrap gap-3">
        {AUDIENCE_ROLES.map((role) => (
          <label
            key={role.value}
            className="inline-flex items-center gap-2 bg-white border border-amber-100/40 rounded-full px-4 py-2 text-sm font-bold text-primary-dark cursor-pointer hover:border-secondary/40 transition-all"
          >
            <input
              type="checkbox"
              checked={value.includes(role.value)}
              onChange={() => toggleRole(role.value)}
              className="h-4 w-4 rounded-md border-amber-200 accent-secondary"
            />
            <span className="material-symbols-outlined text-secondary" style={{ fontSize: '18px' }}>
              {role.icon}
            </span>
            {role.label}
          </label>
        ))}
      </div>
      {value.length === 0 && (
        <p className="mt-3 text-xs font-bold text-red-600">Select at least one audience</p>
      )}
    </div>
  );
};

export default AudienceCheckboxGroup;
